import * as angular from 'angular';
import { GithubFacade } from '@mode/github/contract';

export const workspaceSettingsGithubDirective = function (githubFacade: GithubFacade) {
  return {
    link: function ($scope: angular.IScope, $elem: JQuery) {
      $elem.on('click', '.push-button', (event) => {
        githubFacade.dispatch(
          GithubFacade.Actions.workspaceSettingsPushedChangesToGithub({
            dialogData: {
              syncType: $scope['syncType'],
              workspace: $scope['workspace'],
              token: $scope['token'],
              defaultCommitMessage: $scope['defaultCommitMessage'],
            },
          })
        );
      });
    },
    restrict: 'A',
    scope: {
      syncType: '@',
      workspace: '@',
      token: '@',
      defaultCommitMessage: '@',
    },
  };
};

workspaceSettingsGithubDirective.$inject = ['GithubFacade'];
